export enum SIGNAL_TYPES {
  ERROR_WORD = 'Error / status signal',
  BYTE_ARRAY = 'Byte array',
  DEFAULT = 'Default'
}